import BaseUnknownError from '../../project-pages-improvement/common/base-unknown-error';
import React from 'react';
import ViewTracker from '../../../common/analytics/view-tracker';
import messages from './messages';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/analytics-bridge';

const UnknownError = () => {
	return (
		<>
			<BaseUnknownError messages={messages} />
			<ViewTracker />
		</>
	);
};

export default () => (
	<ContextualAnalyticsData sourceName="projectPagesUnknownError" sourceType={SCREEN}>
		<UnknownError />
	</ContextualAnalyticsData>
);
